import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./Auth.css";
import icon from "../../assets/icon.png";
import AboutAuth from "./AboutAuth";
import { signup, login } from "../../actions/auth";
const Auth = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSwitch = () => {
    setIsSignup(!isSignup);
    setName("");
    setEmail("");
    setPassword("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email && !password) {
      alert("Enter email and password");
    }
    if (isSignup) {
      if (!name) {
        alert("Enter a name to continue");
      }
      dispatch(signup({ name, email, password }, navigate));
    } else {
      dispatch(login({ email, password }, navigate));
    }
  };

  return (
    <section className="auth-section">
      <div className={`auth-wrapper ${isSignup ? "signup-mode" : ""}`}>
        {isSignup && (
          <div className="auth-left">
            <AboutAuth />
          </div>
        )}

        <div className="auth-right">
          <div className="auth-card">
            <h2 className="auth-title">
              {isSignup ? "Create your Dev Q account" : "Log in to Dev Q"}
            </h2>

            <form onSubmit={handleSubmit}>
              {isSignup && (
                <label>
                  <span>Display Name</span>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </label>
              )}

              <label>
                <span>Email</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>

              <label>
                <span>Password</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>

              <button type="submit" className="auth-btn">
                {isSignup ? "Sign up" : "Log in"}
              </button>
            </form>

            <p className="auth-switch">
              {isSignup ? "Already have an account?" : "Don't have an account?"}
              <button
                type="button"
                className="handle-switch-btn"
                onClick={handleSwitch}
              >
                {isSignup ? "Log in" : "Sign up"}
              </button>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Auth;
